import {FETCH_INTERVENTIONS, RESET_FILTERS, SET_FILTERS, TOGGLE_ARCHIVED} from "../constants/ActionTypes";
import Constants from "../services/Constants";

const initPagination = {
    currentPage: 1,
    currentPageSize: 10,
    totalElements: 10,
};

const initFilters = {
  interventionStatus: [],
  advisor: [],
  carBrand: [],
  origins: [],
  type: [],
}

const initialState = {
  interventions: [],
  initPagination: initPagination,
  pagination: initPagination,
  showArchived: false,
  filters: initFilters,
  appliedFilters: initFilters,
  initFilters: initFilters,
  counters: {
    interventionStatus: {},
    type: {}
  },
};

export function fetchInterventions(state = initialState, action) {
  switch (action.type) {
    case FETCH_INTERVENTIONS:
      return {
        ...state,
        appliedFilters: action.filters,
        pagination: {
          currentPage:  action.parameters.page,
          currentPageSize:  action.parameters.size,
        },
      }
    case 'FETCH_INTERVENTIONS.SUCCESS':
    case 'FETCH_INTERVENTIONS_OVERVIEW.SUCCESS':
      return {
        ...state,
        interventions:  action.interventions.body,
        counters: {
          interventionStatus:  action.statusCounters,
          type:  action.typeCounters,
        },
        pagination: {
          currentPage:  action.interventions.body.number+1,
          currentPageSize:  action.interventions.body.size,
          totalElements: action.interventions.body.totalElements
        },
      };
    case TOGGLE_ARCHIVED:
      return {
        ...state,
        showArchived: action.showArchived,
      };
    case SET_FILTERS:
      return {
        ...state,
        filters: action.filters,
      };
    case RESET_FILTERS:
      return {
        ...state,
        filters: {
          interventionStatus: [],
          advisor: [],
          carBrand: [],
          origins: [],
          type: [],
        },
      };
    default:
      return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/reducers/interventions.js